import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConversacionesBorradasService {
  private readonly borradas = new Subject<void>();
  public readonly borradas$: Observable<void> = this.borradas.asObservable();

  public notificar(): void {
    this.borradas.next();
  }
}
